<template>
	
	<v-app class="grey lighten-1">
        <v-content>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4 lg4 >

                        <v-form ref="vForm" v-on:submit.prevent="submit">

                            <v-card class="elevation-1 ">
                                <v-card-title>
                                    <!-- <img :src="logo" class="mr-4" style="width:10%;  display:inline-block;"> -->
                                    <h1 class="font-weight-light display-1 black--text display:inline-block;"><span class="red--text text--darken-4">Forgot</span> Payslip Password</h1>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text>
                                    <div class="red--text">
                                       * Account must be active otherwise will not proceed
                                    </div>
                                    
									<div class="layout column ">
                                        <div v-if="errorMessage" class="red--text">
                                            <v-alert :value="true" color="error" outline>
                                               {{errorMessage}}
                                            </v-alert>
                                        </div>
                                    </div>

                                    <v-text-field :disabled="loading" :rules="[formRules.required]" prepend-icon="fa-id-card" label="Employee ID" v-model="models.employee_id"></v-text-field>
                                    <v-text-field :disabled="loading" :rules="[formRules.required]" prepend-icon="fa-unlock-alt" label="Password" v-model="models.password" type="password"></v-text-field>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions class="pa-3">
                                    <router-link v-if="!loading" :to="`/login`">Back to Login</router-link>
                                    <v-spacer></v-spacer>
                                    <v-btn :loading="loading" type="submit" class="red darken-2 white--text"  >SUBMIT</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-form>
                    </v-flex>

                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>

import VueCookies from 'vue-cookies';
import axios from 'axios';


export default {

	mounted : function(){

	},

	data : function() {
		return {
			token : '',
			models : {
				employee_id : '',
				password : ''
			},
			loading : false,
			errorMessage : null
		}
	},

	methods : {
		submit : function(){

			let _this = this,
				formData = new FormData();

			formData.append("employee_id", this.models.employee_id);
			formData.append("password", this.models.password);

			if(_this.$refs.vForm.validate()){
				_this.loading = true;

				axios
	            .post(_this.apiUrl+'/users/forgot/payslip/password', formData)
	            .then((res) => {
	            	if(res.data.status){

                        _this.$swal('Succcess!', res.data.message, 'success').then(function(result){

                            _this.$router.push('/login');

                        });

	            		_this.errorMessage = null;
	            	}else{
	            		_this.errorMessage = res.data.message;
	            	}

	            	_this.loading = false;
	            });
			}

		}

	}


};

</script>